(function () {
  var button = document.querySelector('.f24-scroll-top');
  if (!button) return;

  var threshold = 420;
  var ticking = false;

  function setVisible() {
    var visible = window.scrollY > threshold;
    button.hidden = false;
    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      setVisible();
    });
  }

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  setVisible();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
